import React, { useEffect, useState } from 'react';
import { resolveMedia } from '../lib/media';

const LEGACY_BANNER = 'https://customer-assets.emergentagent.com/job_site-mirror-165/artifacts/q7uexyzq_banner%20footer%20sponsor%20tp.png';
const LEGACY_HOTSPOTS = [
  { name: 'BM Records', url: 'https://www.bmrecords.eu/', left: 4, width: 8 },
  { name: 'Foundation', url: 'https://hiphoperafoundation.it/', left: 13, width: 7 },
  { name: 'Hip Hop Kemp', url: 'https://www.hiphopkemp.cz/it/', left: 21, width: 7 },
  { name: 'All Bars Game', url: 'https://www.youtube.com/@All_Bars_Game', left: 29, width: 8 },
  { name: 'The Dome', url: 'https://www.youtube.com/@THEDOMETV/videos', left: 38, width: 8 },
  { name: 'Londinese', url: 'https://londinese.it/', left: 47, width: 8 },
  { name: 'Conditio Et Intellectus', url: 'https://hhcei.eu/', left: 56, width: 8 },
  { name: 'Il Rappuso', url: 'https://www.ilrappuso.com/', left: 65, width: 14 },
  { name: 'Say Waaad?', url: 'https://www.instagram.com/saywaaad/', left: 80, width: 7 },
  { name: '4P', url: 'https://www.instagram.com/4thpotere/', left: 88, width: 7 },
];

const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const LegacyBanner = () => (
  <div className="relative w-full max-w-5xl">
    <img src={LEGACY_BANNER} alt="Support & Sponsor - Tecniche Perfette Partners"
      className="w-full h-auto object-contain opacity-90 hover:opacity-100 transition-opacity duration-300" />
    {LEGACY_HOTSPOTS.map((logo) => (
      <a key={logo.name} href={logo.url} target="_blank" rel="noopener noreferrer" title={logo.name} aria-label={logo.name}
        data-testid={`sponsor-hotspot-${slug(logo.name)}`}
        className="absolute top-[35%] block hover:bg-red-500/10 transition-colors duration-200 rounded"
        style={{ left: `${logo.left}%`, width: `${logo.width}%`, height: '40%' }} />
    ))}
  </div>
);

const SponsorLogos = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-content/sponsors`)
      .then(r => r.json())
      .then(d => setItems(Array.isArray(d.items) ? d.items : []))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return <LegacyBanner />;

  return (
    <div className="w-full max-w-5xl flex flex-wrap justify-center items-center gap-x-8 gap-y-6 sm:gap-x-12" data-testid="sponsor-logos-grid">
      {items.map((sp) => {
        const content = sp.logo ? (
          <img src={resolveMedia(sp.logo)} alt={sp.name} loading="lazy"
            className={`${sp.featured ? 'h-14 sm:h-20 max-w-[180px] sm:max-w-[240px]' : 'h-10 sm:h-14 max-w-[120px] sm:max-w-[160px]'} object-contain grayscale opacity-75 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300`} />
        ) : (
          <span className="text-gray-400 group-hover:text-white text-xs sm:text-sm font-bold tracking-wider transition-colors" style={{ fontFamily: 'Oswald, sans-serif' }}>
            {sp.name.toUpperCase()}
          </span>
        );
        const cls = 'group inline-flex items-center justify-center min-h-[40px]';
        return sp.url ? (
          <a key={sp.name} href={sp.url} target="_blank" rel="noopener noreferrer" title={sp.name} aria-label={sp.name}
            data-testid={`sponsor-logo-${slug(sp.name)}`} className={cls}>
            {content}
          </a>
        ) : (
          <span key={sp.name} title={sp.name} data-testid={`sponsor-logo-${slug(sp.name)}`} className={cls}>{content}</span>
        );
      })}
    </div>
  );
};

export default SponsorLogos;
